import { useMutation } from "react-query";
import { ReferralApi } from "../../services";
export const useUpdateReferralCode = () => {
    return useMutation("ReferralApi.updateReferralCode", ({ referralCode, uuid, ciam_token, source, }) => {
        return ReferralApi.init().updateReferralCode(uuid, referralCode, ciam_token, source);
    });
};
//# sourceMappingURL=useUpdateReferralCode.js.map